import React, { useEffect } from "react";
import Lottie from "lottie-react";
import whatsappAnimation from "../animations/whatsapp.json";

/**
 * Full-Screen Splash Animation
 *
 * Displays a full-screen WhatsApp animation when navigating to dashboard
 * Shows for 1-2 seconds then calls onComplete callback
 */
const SplashScreen = ({ onComplete, duration = 2000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, duration);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-green-600 via-green-500 to-green-700">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white opacity-10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-white opacity-10 rounded-full blur-3xl animate-pulse delay-700"></div>
      </div>

      {/* Animation Container */}
      <div className="relative z-10">
        <div className="w-64 h-64 md:w-80 md:h-80">
          <Lottie
            animationData={whatsappAnimation}
            loop={true}
            autoplay={true}
          />
        </div>

        {/* Loading Text */}
        <div className="text-center mt-8">
          <h2 className="text-white text-2xl font-bold mb-2">WA Promotion</h2>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce delay-100"></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce delay-200"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
